/* beautiful-react-hooks version: 0.31.1 */
import useStorage from './useStorage.js';

var useLocalStorage = useStorage('local');

export default useLocalStorage;
